// removed by extract-text-webpack-plugin
module.exports = {"item":"src-components-PrimaryNavigation-LinkItem----LinkItem-module---item---37Pux","link":"src-components-PrimaryNavigation-LinkItem----LinkItem-module---link---CLNoL","submenu":"src-components-PrimaryNavigation-LinkItem----LinkItem-module---submenu---3iSLi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PrimaryNavigation/LinkItem/LinkItem.module.scss
// module id = 1195
// module chunks = 114276838955818